/* eslint-disable */
import './App.css';
import Sidebar from './Sidebar';
import Profile from './Profile';
import Contact from './Contact';
import Publications from './Publications';
import Education from './Education';
import WorkExp from './WorkExp';
import TeachingExp from './TeachingExp';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';


function App() {
  return (
    <Router>
      <div className="App">
        <Sidebar/>
        <Routes>
          <Route exact path="/side" element={<Sidebar/>}/>
          <Route exact path='/' element={
            <>
            <Profile/> <hr/>
            <Contact/> <hr/>
            <Publications/> <hr/>
            <Education/> <hr/>
            <WorkExp/> <hr/>
            <TeachingExp/>
            </>
          }/>
          <Route exact path="/Profile" element={<Profile/>} />
          <Route exact path="/Contact" element={<Contact/>} />
          <Route exact path="/Publications" element={<Publications/>} />
          <Route exact path="/Education" element={<Education/>} />
          <Route exact path="/WorkExp" element={<WorkExp/>} />
          <Route exact path="/TeachingExp" element={<TeachingExp/>} />
        </Routes>

      </div>
    </Router>
  );
}
export default App;
